/**
 * Crafting recipes for the brewing chain: brewing stand, glass bottles, bowls, sugar,
 * fermented spider eye, glistering melon and suspicious stew. Registered into the shared
 * table by recipes.ts (kept here so the potion work stays out of that file's body).
 */

import * as B from '../../blocks';
import { I } from '../itemIds';
import { stackOf } from '../types';
import { STEW_FLOWERS, stewFlowerBlock } from '../effects/sources';

type Ingredient = number | readonly number[];
interface RecipeLike { shaped: boolean; w: number; h: number; ing: readonly Ingredient[]; result: ReturnType<typeof stackOf> }

const MUSHROOM_RED = 118, MUSHROOM_BROWN = 119;
const COBBLES = [B.COBBLE_ID, B.COBBLED_DEEPSLATE_ID];

export function registerBrewingRecipes(out: RecipeLike[], planks: readonly number[]): void {
  const shaped = (rows: string[], key: Record<string, Ingredient>, id: number, count = 1): void => {
    const ing: Ingredient[] = [];
    for (const r of rows) for (const ch of r) ing.push(ch === ' ' ? 0 : key[ch]);
    out.push({ shaped: true, w: rows[0].length, h: rows.length, ing, result: stackOf(id, count) });
  };
  const shapeless = (ing: Ingredient[], id: number, count = 1, dmg = 0): void => {
    out.push({ shaped: false, w: 0, h: 0, ing, result: stackOf(id, count, dmg) });
  };
  shaped([' R ', 'CCC'], { R: I.BLAZE_ROD, C: COBBLES }, B.BREWING_STAND_ID);
  shaped(['G G', ' G '], { G: B.GLASS_ID }, I.GLASS_BOTTLE, 3);
  shaped(['P P', ' P '], { P: planks }, I.BOWL, 4);
  shapeless([B.SUGAR_CANE_ID], I.SUGAR);
  shapeless([I.SPIDER_EYE, MUSHROOM_BROWN, I.SUGAR], I.FERMENTED_SPIDER_EYE);
  shaped(['NNN', 'NMN', 'NNN'], { N: I.GOLD_NUGGET, M: I.MELON_SLICE }, I.GLISTERING_MELON_SLICE);
  // suspicious stew: bowl + both mushrooms + a flower decides the effect
  STEW_FLOWERS.forEach((_f, i) => {
    const block = stewFlowerBlock(i);
    if (block > 0) shapeless([I.BOWL, MUSHROOM_RED, MUSHROOM_BROWN, block], I.SUSPICIOUS_STEW, 1, i);
  });
}
